<template>
  <div class="trun-user">
    <!-- <div class="page-handle">
      <div class="left">
        <a-button>添加样本类型</a-button>
      </div>
    </div> -->
    <div class="page-content page-turn-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :dataSource="data"
        :rowKey="record => record.dictId"
        class="hospital-table"
        size="middle"
      >
        <template slot="handle" slot-scope="text,record,index">
          <router-link to="/" class="cf-mr10">编辑</router-link>
          <router-link to @click.native="delSampleType(record)">删除</router-link>
        </template>
      </a-table>
    </div>
    <div class="pagination">
      <a-pagination
        @change="pageChange"
        :pageSize.sync="pageSize"
        v-model="page"
        size="small"
        :total="dictData.total"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    title: "名称",
    dataIndex: "dictValue"
  },
  {
    title: "创建时间",
    dataIndex: "createTime"
  },
  {
    title: "操作",
    scopedSlots: { customRender: "handle" },
    width: "15%"
  }
];
export default {
  data() {
    return {
      columns,
      visible: false,
      data: [],
      page: 1,
      pageSize: 10,
      dictData: {}
    };
  },
  components: {},
  mounted() {
    this.getList();
  },
  methods: {
    delSampleType(row) {
    },
    pageChange(page, pagesize) {
      this.page = page;
      this.pageSize = pagesize;
      this.getList();
    },
    getList() {
      this.$get("info/commonDict", {
        dictType: "sampleType",
        pageSize: this.pageSize,
        pageNum: this.page
      }).then(
        res => {
          this.dictData = res.data.data;
          this.data = this.dictData.rows;
        },
        err => {
          this.$message.error("获取列表失败");
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.trun-user {
  .pagination {
    padding: 0 30px;
  }
}
</style>